import { type } from '@testing-library/user-event/dist/type';
import { handleRequest } from 'msw';
import React, { useState } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { EffectCoverflow, Pagination } from 'swiper/modules';

import 'swiper/css';
import 'swiper/css/pagination';

// import required modules

const SystemPage = (prop) => {


  return (
    <div className="cSystemPage">
      <img className='cBg' src={window.assetUrl('/images/system/bg.jpg')} />
      <img className='cPhoneBg' src={window.assetUrl('/images/system/phone-bg.jpg')} />
      <img className='cTitle cTitleInit' ref={prop.systemTitleRef} src={window.assetUrl('/images/system/title.png')} />
      <Swiper
        effect={'coverflow'}
        initialSlide={0}
        grabCursor={true}
        centeredSlides={true}
        slidesPerView={'auto'}
        spaceBetween={30}
        coverflowEffect={{
          rotate: 0,
          stretch: 0,
          depth: 300,
          modifier: 1,
          slideShadows: false,
        }}
        loop={true}
        onSlideChange={(swiper) => {
          //console.log('Slide index changed to: ', swiper.realIndex + 1);
        }}
        className="cPhoneSwiper"
      >
        <SwiperSlide>
          <img src={window.assetUrl('/images/system/1.jpg')} />
        </SwiperSlide>
        <SwiperSlide>
          <img src={window.assetUrl('/images/system/2.jpg')} />
        </SwiperSlide>
        <SwiperSlide>
          <img src={window.assetUrl('/images/system/3.jpg')} />
        </SwiperSlide>
        <SwiperSlide>
          <img src={window.assetUrl('/images/system/4.jpg')} />
        </SwiperSlide>
        <SwiperSlide>
          <img src={window.assetUrl('/images/system/5.jpg')} />
        </SwiperSlide>
        <SwiperSlide>
          <img src={window.assetUrl('/images/system/6.jpg')} />
        </SwiperSlide>
        <SwiperSlide>
          <img src={window.assetUrl('/images/system/7.jpg')} />
        </SwiperSlide>
        <SwiperSlide>
          <img src={window.assetUrl('/images/system/8.jpg')} />
        </SwiperSlide>
        <SwiperSlide>
          <img src={window.assetUrl('/images/system/9.jpg')} />
        </SwiperSlide>
        <SwiperSlide>
          <img src={window.assetUrl('/images/system/10.jpg')} />
        </SwiperSlide>
      </Swiper>

      <Swiper
        slidesPerView={'auto'}
        grabCursor={true}
        pagination={{
          clickable: true,
        }}
        modules={[Pagination]}
        className="cPcSwiper"
      >
        <SwiperSlide>
          <img src={window.assetUrl('/images/system/1.jpg')} />
        </SwiperSlide>
        <SwiperSlide>
          <img src={window.assetUrl('/images/system/2.jpg')} />
        </SwiperSlide>
        <SwiperSlide>
          <img src={window.assetUrl('/images/system/3.jpg')} />
        </SwiperSlide>
        <SwiperSlide>
          <img src={window.assetUrl('/images/system/4.jpg')} />
        </SwiperSlide>
        <SwiperSlide>
          <img src={window.assetUrl('/images/system/5.jpg')} />
        </SwiperSlide>
        <SwiperSlide>
          <img src={window.assetUrl('/images/system/6.jpg')} />
        </SwiperSlide>
        <SwiperSlide>
          <img src={window.assetUrl('/images/system/7.jpg')} />
        </SwiperSlide>
        <SwiperSlide>
          <img src={window.assetUrl('/images/system/8.jpg')} />
        </SwiperSlide>
        <SwiperSlide>
          <img src={window.assetUrl('/images/system/9.jpg')} />
        </SwiperSlide>
        <SwiperSlide>
          <img src={window.assetUrl('/images/system/10.jpg')} />
        </SwiperSlide>
      </Swiper>
      <img className="cDownBtn" src={window.assetUrl('/images/home/down.png')} alt="" />
    </div>
  );
};

export default SystemPage;